import Typography from '@mui/material/Typography';
import Modal from '../../../../../shared/Modal/ModalBasic';
import { ISchedules } from '../../../../../../services/journey.service';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { Button } from './styled';
import { formatOnlyDate } from '../../../../../../lib/dayjs';
import { pdf } from '@react-pdf/renderer';
import { useCreateAttendanceDeclarationMutation } from '../../../../../../services/schedule.service';
import { PDFGenerator } from '../../../../../shared/PDFGenerator';
import { useState } from 'react';
import PDFDocument from '../PDFDocument';
import CircularProgress from '@mui/material/CircularProgress';

type Props = {
  open: boolean;
  onFinished: () => void;
  schedules: ISchedules[];
};

const ModalComponent = ({ open, onFinished, schedules }: Props) => {
  const [createAttendanceDeclaration] = useCreateAttendanceDeclarationMutation();
  const [loadingPDF, setLoadingPDF] = useState(false);
  const generatePDF = async (schedule: ISchedules) => {
    const attendanceDeclaration = await createAttendanceDeclaration({ id: schedule.id }).unwrap();
    setLoadingPDF(true);
    const blob = await pdf(
      <PDFGenerator>
        <PDFDocument {...attendanceDeclaration} />
      </PDFGenerator>
    ).toBlob();

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `declaracao-de-comparecimento-${schedule.id}.pdf`;
    link.click();
    URL.revokeObjectURL(url);
    setLoadingPDF(false);
  };

  return (
    <Modal open={open} onCloseHandler={() => onFinished()} title={'Declaração de Comparecimento'} typeTitle="h3">
      <Typography sx={{ mb: 3 }}>Faça o download da sua declaração conforme o agendamento realizado:</Typography>

      {schedules.map(schedule => (
        <Button color="primary" key={schedule.id} onClick={() => generatePDF(schedule)} sx={{ cursor: 'pointer' }}>
          <SaveAltIcon /> Declaração - {formatOnlyDate(schedule.dateStart)}
          {loadingPDF && <CircularProgress size={20} sx={{ color: 'brand.darkGreen' }} />}
        </Button>
      ))}
    </Modal>
  );
};

export default ModalComponent;
